define('score_bootstrap/Components/ContentSearch/MultiViewSearchResults',[
    "jquery",
    "knockout",
    "eventManager",
    "score_bootstrap/Components/ContentSearch/SearchResultsBase",
    "score_bootstrap/Models/Tile",
    "score_bootstrap/Models/Search/SearchRequest",
    "score_bootstrap/Events/SearchResponseEvent",
    "score_bootstrap/Events/MultiViewSearchResultsEvent",
    "score_bootstrap/Utils/UrlHelper"
    
], function (
    $,
    ko,
    eventManager,
    SearchResultsBase,
    Tile,
    SearchRequest,
    SearchResponseEvent,
    MultiViewSearchResultsEvent,
    urlHelper
) {
    "use strict";

    function MultiViewSearchResults(scope, uniqueId, refreshEvents, showTransmitMsg, stateChangeTransmitMsg, showMoreActionMsg, showQvActionMsg, lazySearch) {
        var searchViews = null, self = this;

        this.query = ko.observable("");
        this.serviceUnavailable = ko.observable(false);
        this.numberOfResults = ko.observable("");
        this.canShowMore = ko.observable();
        this.showLazySearchMessage = ko.observable(false);

        Object.defineProperties(this, {
            searchViews: {
                enumerable: false,
                get: function () {
                    if (searchViews == null) {
                        searchViews = $(".score-search-results-view", scope).map(function () {
                            return $(this).data("ccf_module");
                        }).get();
                    }
                    return searchViews;
                }
            },
            activeView: {
                enumerable: false,
                get: function () {
                    var activeViews = $.grep(this.searchViews, function (view) {
                        return view.isActive;
                    });
                    return activeViews.length > 0 ? activeViews[0] : null;
                }
            }
        });

        // show the first view on page load
        var subscription = eventManager.subscribe("ModulesLoadedEvent", function (ev) {
            // append the initial search load with info from the first view
            var view = this.searchViews[0], self = this;

            this.searchClient.searchRequest.perPage = view.tilesPerPage;

            // Change some parameters for initial page loading when the 'switchToClassicPager' is false 
            // and the component has selected page of results different from first.
            // Need to have results from first page to defined in url. 
            if (!view.switchToClassicPager) {
                var currentPageParameter = urlHelper.getHashValue(this.id + "page");
                if (currentPageParameter) {
                    var currentPage = parseInt(currentPageParameter) | 0;
                    this.searchClient.searchRequest.perPage = parseInt(view.tilesPerPage) * (currentPage + 1);
                    this.searchClient.searchRequest.page = 0;
                    this.searchClient.searchRequest.startPage = 0;
                    this.page = 0;
                    // Get back the parameters after initial page loading
                    var pageLoadedSubscription = eventManager.subscribe("SearchResponseEvent:pageLoaded", function (data) {
                        this.searchClient.searchRequest.perPage = view.tilesPerPage;
                        this.searchClient.searchRequest.page = currentPage;
                        this.searchClient.searchRequest.startPage = currentPage;
                        this.page = currentPage;
                        // Ensure that this event handler is called only once
                        eventManager.unsubscribe(pageLoadedSubscription);
                    }.bind(this));
                }
            }

            this.searchClient.searchRequest.tileNames = [view.tileName, view.quickViewTileName];
            view.show();

            // subscribe to view's 'show' events
            $(this.searchViews).on("SearchResultsView.show", function (ev) {
                // freeze height while tabs are changing so that elements under the search results don't jump up and down
                self.$scope.css("height", self.$scope.height());

                self.searchClient.searchRequest.perPage = this.tilesPerPage;

                // Change some parameters for initial page loading when the 'switchToClassicPager' is false
                // and the component has selected page of results different from first.
                // Need to have results from first page to defined in url. 
                if (!this.switchToClassicPager) {
                    var currentPageParameter = urlHelper.getHashValue(self.id + "page");
                    if (currentPageParameter /*&& !initialResultLoadedForEachView*/) {
                        var currentPage = parseInt(currentPageParameter) | 0;
                        self.searchClient.searchRequest.perPage = parseInt(this.tilesPerPage) * (currentPage + 1);
                        self.searchClient.searchRequest.page = 0;
                        self.searchClient.searchRequest.startPage = 0;
                        self.page = 0;
                        // Get back the parameters after rendering of search tiles
                        var searchRenderedSubscription = eventManager.subscribe("search-rendered", function (data) {
                            self.searchClient.searchRequest.perPage = this.tilesPerPage;
                            self.searchClient.searchRequest.page = currentPage;
                            self.searchClient.searchRequest.startPage = currentPage;
                            self.page = currentPage;
                            // Ensure that this event handler is called only once
                            eventManager.unsubscribe(searchRenderedSubscription);
                        }.bind(this));
                    }
                }

                self.searchClient.searchRequest.tileNames = [this.tileName, this.quickViewTileName];
                self.searchClient.search().done(self.appendTiles.bind(self));
            })
            .on("SearchResultsView.showPage", function(ev, newPage) {
                urlHelper.setHashValue(window.location, this.id + "page", newPage);

                self.searchClient.searchRequest.page = newPage;
                self.searchClient.searchRequest.startPage = newPage;
                self.searchClient.searchRequest.perPage = this.tilesPerPage;
                self.searchClient.searchRequest.tileNames = [this.tileName, this.quickViewTileName];

                var searchProm = self.searchClient.search();
                //searchProm.done((function () { this.results.removeAll(); }).bind(this));
                searchProm.done(self.appendTiles.bind(self));
            });

            // Ensure that this event handler is called only once
            eventManager.unsubscribe(subscription);

            //moduleLoader.loadPendingModules(this.activeView.$list);
        }.bind(this));

        if (showMoreActionMsg.length) {
            showMoreActionMsg.forEach(function (msg) {
                eventManager.subscribe(msg, function () {
                    self.showMore();
                });
            });
        }

        if (showQvActionMsg.length) {
            showQvActionMsg.forEach(function (msg) {
                eventManager.subscribe(msg, function (component) {
                    var $li = component.$scope.closest("li"),
                        view = self.activeView,
                        tile = view.getQuickViewTileByElement($li);

                    view.showQuickView(tile, $li);
                });
            });
        }

        if (stateChangeTransmitMsg.length) {
            this.canShowMore.subscribe(function (canShowMore) {
                stateChangeTransmitMsg.forEach(function (msg) {
                    if ((msg == MultiViewSearchResultsEvent.hasMoreResults && canShowMore) ||
                        (msg == MultiViewSearchResultsEvent.noMoreResults && !canShowMore)) {
                            eventManager.trigger(msg, self);
                    }
                });
            });
        }

        ko.applyBindings(this, scope);

        SearchResultsBase.call(this, scope, uniqueId, lazySearch, refreshEvents, showTransmitMsg);
    }

    MultiViewSearchResults.prototype = Object.create(SearchResultsBase.prototype);

    MultiViewSearchResults.prototype.reset = function reset() {
        this.page = 0;
        this.searchViews.forEach(function (view) {
            view.reset();
        });
    };

    MultiViewSearchResults.prototype.appendTiles = function appendTiles(response) {
        var isLoadMore = false;
        this.serviceUnavailable(false);

        if (response.page !== this.page) {
            urlHelper.setHashValue(window.location, this.id + "page", String(response.page));
        }

        if (response.page <= this.page) {
            // When there is a new search response, current tiles should always be cleared out first,
            // unless the 'page' value has been incremeneted, which means that 'show more' was clicked
            // this.page = 0;
            this.activeView.reset();
        } else {
            // 'show more' was clicked, so page should be incremented
            this.page = response.page;
            isLoadMore = true;
        }

        this.canShowMore((response.page + 1) < response.totalPages);
        this.numberOfResults(response.totalItems);
        this.query(response.query);

        var newTiles = this.activeView.appendTiles(response, isLoadMore);

        if (this.$scope.hasClass("js-hide-on-load")) {
            this.$scope.removeClass("js-hide-on-load");
        }

        this.$scope.css("height", "");

        // call base class implementation
        SearchResultsBase.prototype.appendTiles.call(this, newTiles);
    };

    MultiViewSearchResults.init = function init(args) {
        return new MultiViewSearchResults(
            args.scope,
            args.UniqueId,
            args.RefreshActionMessages || [],
            args.ShowMessagesTransmitting || [],
            args.StateChangeMessagesToTransmitOn || [],
            args.ShowMoreMessagesToPerformOn || [],
            args.ShowQuickViewMessagesToPerformOn ||[],
            args.LazySearch);
    };

    return MultiViewSearchResults;
});
